import storage from "@/storage";
import { defineStore } from 'pinia' 

export const useCommonStore = defineStore("common", {
  state: () => {
    return {
      sessionID: null,
      expiry: null
    }
  },
  // getters: {
  //   getSessionID: state => state.sessionID
  // },
  actions: {
    updateSessionID(val) {
      this.sessionID = val
    },
    async updateExpiry(val) {
      await storage.common.setItem(this.sessionID, val);
      this.expiry = val;
    },
    resetSessionID() {
      this.sessionID = null
    }
  },
  persist: true
});
